import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "children"];
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { STATUS_TYPES } from '../../constants/STATUS';
import { statusIconAppearance } from '../../util/statusIconAppearance';
import { InlineFeedbackMixin } from '../../mixins/components/InlineFeedbackMixin';
export var StyledInlineFeedback = /*#__PURE__*/styled.p.withConfig({
  displayName: "StyledInlineFeedback",
  componentId: "c11n-8-64-0__sc-2lje6f-0"
})(["", ""], InlineFeedbackMixin);
/**
 * `InlineFeedback` is a subtle status message that is embedded within the content of the page.
 * For a more prominent message, consider using the [`Alert`](#/Messaging%20components?id=alert)
 * component.
 *
 * @since 7.17.0
 */

var InlineFeedback = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var icon = props.icon,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var iconContent = icon;

  if (typeof icon === 'function') {
    iconContent = icon(props);
  }

  return /*#__PURE__*/React.createElement(StyledInlineFeedback, _extends({
    ref: ref
  }, rest), iconContent, children);
});
InlineFeedback.displayName = 'InlineFeedback';
InlineFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type and style of inline feedback to display.
   */
  appearance: PropTypes.oneOf([].concat(_toConsumableArray(Object.keys(STATUS_TYPES)), ['transient'])),

  /**
   * The icon node. By default, this will use an icon based on the inline feedback `appearance`.
   */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * The text content of the inline feedback message.
   */
  children: PropTypes.node.isRequired
} : {};
InlineFeedback.defaultProps = {
  appearance: 'info',
  icon: statusIconAppearance
};
export default InlineFeedback;